import React from "react";

function SettingsPanel({
  show,
  compactMode,
  isMobileLike,
  setShowHelpModal,
  setShowMore,
  handleToggleFullscreen,
  handleCopyRoomLink,
  meetingRole,
  user,
  TranscriptionToggleRow,
  WaitingRoomToggleRow,
  GuestCanUnmuteToggleRow,
  ApprovalSoundToggleRow,
  AINoiseRemovalToggleRow,
  webinarMode = false,
}) {
  console.log(meetingRole);
  if (!show) return null;

  // Mobile positioning above the bottom bar
  if (isMobileLike) {
    return (
      <>
        {/* Settings Panel */}
        <div
          data-more-dropdown
          className="fixed bottom-20 left-0 right-0 z-[10000] bg-[#060621] rounded-t-2xl shadow-xl border-t border-gray-600 py-4 px-4 max-h-[60vh] overflow-y-auto transition-all duration-300 ease-in-out"
        >
          {/* Close button */}
          <div className="flex justify-end mb-2">
            <button
              onClick={() => setShowMore(false)}
              className="text-gray-400 hover:text-white transition-colors p-1"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          {!webinarMode && (
            <button
              className="w-full text-left px-3 py-2 text-white hover:bg-white/10 flex items-center gap-2"
              onClick={() => {
                setShowHelpModal(true);
                setShowMore(false);
              }}
            >
              Feedback
            </button>
          )}
          <button
            className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
            onClick={handleToggleFullscreen}
          >
            Toggle Full Screen
          </button>
          <button
            className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
            onClick={handleCopyRoomLink}
          >
            Copy Room Link
          </button>

          {user?.plan == "Business" && !webinarMode && (
            <TranscriptionToggleRow className="" />
          )}
          {!webinarMode && <div className="h-px bg-gray-600 my-2" />}

          {meetingRole === "moderator" && !webinarMode && (
            <>
              <WaitingRoomToggleRow className="" />

              <GuestCanUnmuteToggleRow className="" />

              <ApprovalSoundToggleRow className="" />
            </>
          )}

          <AINoiseRemovalToggleRow className="" />
        </div>
      </>
    );
  }

  // Desktop positioning: absolute dropdown
  return (
    <div
      data-more-dropdown
      className={`absolute top-full right-0 mt-2 w-80 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-[10000] py-3 px-4 transition-all duration-300 ease-in-out`}
    >
      {!webinarMode && (
        <button
          className="w-full text-left px-3 py-2  text-white hover:bg-white/10 flex items-center gap-2"
          onClick={() => {
            setShowHelpModal(true);
            setShowMore(false);
          }}
        >
          Feedback
        </button>
      )}
      <button
        className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
        onClick={handleToggleFullscreen}
      >
        Toggle Full Screen
      </button>
      <button
        className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
        onClick={handleCopyRoomLink}
      >
        Copy Room Link
      </button>

      {user?.plan == "Business" && !webinarMode && (
        <TranscriptionToggleRow className="" />
      )}
      {!webinarMode && <div className="h-px bg-gray-600 my-2" />}

      {meetingRole === "moderator" && !webinarMode && (
        <>
          <WaitingRoomToggleRow className="" />

          <GuestCanUnmuteToggleRow className="" />

          <ApprovalSoundToggleRow className="" />
        </>
      )}

      <AINoiseRemovalToggleRow className="" />
    </div>
  );
}

export default SettingsPanel;
